import React from 'react';
import {useTranslation} from 'react-i18next';
import {FaIcon} from '../FaIcon';
import {LayoutSidebar} from '../../Layout';
import {SupportChatService} from '../support_chat/SupportChatService';

export function CustomMetricsUpgradePage({mode = 'beta'}) {
    const {t} = useTranslation();
    const isBeta = mode === 'beta';

    const handlePrimaryClick = (e) => {
        e.preventDefault();
        const messageKey = isBeta
            ? 'custom_metrics.upgrade.intercom_beta'
            : 'custom_metrics.upgrade.intercom_plan_locked';
        SupportChatService.showNewMessage(t(messageKey));
    };

    const benefits = [
        {
            icon: 'link',
            titleKey: 'custom_metrics.upgrade.benefit_1_title',
            descKey: 'custom_metrics.upgrade.benefit_1_desc',
        },
        {
            icon: 'chart-line',
            titleKey: 'custom_metrics.upgrade.benefit_2_title',
            descKey: 'custom_metrics.upgrade.benefit_2_desc',
        },
        {
            icon: 'circle-check',
            titleKey: 'custom_metrics.upgrade.benefit_3_title',
            descKey: 'custom_metrics.upgrade.benefit_3_desc',
        },
    ];

    return (
        <div className="app-content">
            <LayoutSidebar/>
            <section className="section-content">
                <div className="upgrade-to-dashbo-page cm-upgrade-page">
                    <div className="upgrade-hero">
                        <div className={`upgrade-hero-badge ${isBeta ? '-beta' : '-plan'}`}>
                            <span className="icon"><FaIcon iconName={isBeta ? 'wand-magic-sparkles' : 'crown'}/></span>
                            {t(isBeta
                                ? 'custom_metrics.upgrade.badge_beta'
                                : 'custom_metrics.upgrade.badge_plan_locked')}
                        </div>

                        <div className="cm-upgrade-main-icon">
                            <FaIcon iconName="calculator"/>
                        </div>

                        <h1 className="upgrade-hero-title">{t('custom_metrics.upgrade.title')}</h1>
                        <p className="upgrade-hero-subtitle">{t('custom_metrics.upgrade.subtitle')}</p>

                        <div className="cm-formula-mock" aria-hidden="true">
                            <div className="cm-formula-name">{t('custom_metrics.upgrade.formula_example_name')}</div>
                            <div className="cm-formula-body">
                                <span className="cm-token cm-token-paren">(</span>
                                <span className="cm-token cm-token-google">$Google_Conversions</span>
                                <span className="cm-token cm-token-op"> + </span>
                                <span className="cm-token cm-token-meta">$Meta_Conversions</span>
                                <span className="cm-token cm-token-paren">)</span>
                                <span className="cm-token cm-token-op"> / </span>
                                <span className="cm-token cm-token-spend">$Total_Spend</span>
                                <span className="cm-cursor"/>
                            </div>
                            <div className="cm-formula-preview">
                                {t('custom_metrics.upgrade.formula_preview_label')}
                                <strong> 4.2x</strong>
                                <span className="cm-trend"> ▲ 12%</span>
                                {' '}{t('custom_metrics.upgrade.formula_preview_vs')}
                            </div>
                        </div>

                        <div className="upgrade-hero-cta-row">
                            <button
                                type="button"
                                className="btn -alt upgrade-hero-cta"
                                onClick={handlePrimaryClick}
                            >
                                {t(isBeta
                                    ? 'custom_metrics.upgrade.cta_beta'
                                    : 'custom_metrics.upgrade.cta_plan_locked')}
                            </button>
                            <a
                                href="#"
                                className="cm-upgrade-secondary-link"
                                onClick={handlePrimaryClick}
                            >
                                {t(isBeta
                                    ? 'custom_metrics.upgrade.secondary_beta'
                                    : 'custom_metrics.upgrade.secondary_plan_locked')}
                                {' →'}
                            </a>
                        </div>
                    </div>

                    <div className="upgrade-benefits">
                        <h2 className="upgrade-section-title">
                            {t('custom_metrics.upgrade.benefits_section_title')}
                        </h2>
                        <div className="benefits-grid cm-benefits-grid">
                            {benefits.map((b, i) => (
                                <div key={i} className="benefit-card">
                                    <div className="benefit-card-icon">
                                        <span className="icon"><FaIcon iconName={b.icon}/></span>
                                    </div>
                                    <h3>{t(b.titleKey)}</h3>
                                    <p>{t(b.descKey)}</p>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
}
